import React from "react";
import PageContent from "./PageContent";
import PageHeader from "./PageHeader";
import PageNavigation from "./PageNavigation";

function PageBody(props) {
    return (
        <section className="page-body">
            <PageHeader {...props} />
            <PageNavigation {...props} />
            <PageContent />
        </section>
    );
}

export default PageBody;
